/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from "react";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import { ExcelRenderer } from "react-excel-renderer";
import { useCreateKioskOpenOrders } from "utils/apis/kiosk.api";
import { showToast } from "utils/helper";
import {
  Button,
  cn,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@repo/ui";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import { formatDate } from "date-fns";

interface DenominationDetail {
  denomination: string;
  noOfNotes: number;
}

interface KioskLocationDetail {
  serviceDateTime: string | null; // ISO string
  invoicingModel: string;
  jobType: string;
  jobNature: string;
  isBinClearance: boolean;
  routeNo: string;
  priority: number;
  model: string;
  barcode: string;
  denominations: DenominationDetail[];
  expanded?: boolean;
}

interface DetailComponentProps {
  dataItem: KioskLocationDetail;
}

function DetailComponent({ dataItem }: DetailComponentProps) {
  const data = dataItem.denominations || [];
  if (data && data.length > 0) {
    return (
      <Grid data={data} style={{ width: "100%" }}>
        <Column field="denomination" title="Denomination" />
        <Column field="noOfNotes" title="No of Notes" />
      </Grid>
    );
  }
  return <div style={{ height: "50px", width: "100%" }} />;
}

export default function KioskOpenModelRequests({
  openFileUpload,
  setOpenFileUpload,
}: {
  openFileUpload: boolean;
  setOpenFileUpload: (open: boolean) => void;
}) {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [kioskLocations, setKioskLocations] = useState<KioskLocationDetail[]>(
    []
  );

  const {
    mutate: createKioskOpenOrders,
    isSuccess: kioskOrdersSuccess,
    isError: kioskOrdersError,
    isPending: kioskOrdersPending,
  } = useCreateKioskOpenOrders();

  useEffect(() => {
    if (kioskOrdersSuccess) {
      showToast("success", "Kiosk open model orders created successfully!");
      setKioskLocations([]);
      setOpenFileUpload(false);
    }
    if (kioskOrdersError) {
      showToast("error", "Failed to create kiosk open model orders.");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kioskOrdersSuccess, kioskOrdersError]);

  const fileHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fileObj = event.target.files?.[0];
    if (!fileObj) return;

    ExcelRenderer(fileObj, (err: any, resp: any) => {
      if (err) {
        showToast("error", err?.toString() || "Failed to read file");
        return;
      }

      const rows: any[][] = resp.rows || [];
      if (!rows || rows.length === 0) {
        showToast("error", "No data found in excel file.");
        return;
      }

      const headerRow = (rows[0] || []).map((h: any) =>
        h === null || h === undefined ? "" : String(h).trim()
      );

      // Normalize header name to compare
      const normalize = (s: string) =>
        s.replace(/[^a-z0-9]/gi, "").toLowerCase();

      const mapping: Record<string, number> = {};
      const denomCols: { index: number; name: string }[] = [];

      const known: Record<string, string> = {
        barcode: "barcode",
        locationbarcode: "barcode",
        servicedatetime: "serviceDateTime",
        servicedate: "serviceDateTime",
        serviceDateTime: "serviceDateTime",
        jobtype: "jobType",
        binclearance: "binClearance",
        invoicingmodel: "invoicingModel",
        jobnature: "jobNature",
        priority: "priority",
        prority: "priority",
        routeNo: "routeNo",
        routeno: "routeNo",
        model: "model",
      };

      headerRow.forEach((h: string, idx: number) => {
        const key = normalize(String(h || ""));
        if (!key) return;
        if (known[key]) {
          mapping[known[key]] = idx;
        } else {
          denomCols.push({ index: idx, name: h });
        }
      });

      const locations: KioskLocationDetail[] = [];

      for (let r = 1; r < rows.length; r++) {
        const row = rows[r];
        if (!row) continue;

        const barcodeCell = row[mapping.barcode] ?? row[0];
        const barcode =
          barcodeCell !== undefined && barcodeCell !== null
            ? String(barcodeCell).trim()
            : "";
        // skip rows without barcode
        if (!barcode) continue;

        const jobType = row[mapping.jobType] ?? row[1] ?? "";
        const binClearanceCell = row[mapping.binClearance] ?? row[2] ?? "";
        const invoicingModel = row[mapping.invoicingModel] ?? row[3] ?? "";
        const jobNature = row[mapping.jobNature] ?? row[4] ?? "";
        const priorityCell = row[mapping.priority] ?? row[5] ?? 0;
        const routeNo = row[mapping.routeNo] ?? row[6] ?? "";
        const model = row[mapping.model] ?? row[7] ?? "";

        const isBinClearance = Boolean(
          binClearanceCell !== undefined &&
            String(binClearanceCell).trim() !== ""
        );

        const parsedPriority = Number(priorityCell);
        const priority = Number.isNaN(parsedPriority) ? 0 : parsedPriority;

        const denominations: DenominationDetail[] = [];
        denomCols.forEach((dc) => {
          const raw = row[dc.index];
          const num =
            raw === null || raw === undefined || raw === "" ? 0 : Number(raw);
          const noOfNotes = Number.isNaN(num) ? 0 : Math.floor(num);
          if (noOfNotes > 0) {
            denominations.push({ denomination: dc.name, noOfNotes });
          }
        });

        const loc: KioskLocationDetail = {
          serviceDateTime: formatDate(
            selectedDate,
            "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"
          ),
          invoicingModel: invoicingModel ? String(invoicingModel).trim() : "",
          jobType: jobType ? String(jobType).trim() : "",
          jobNature: jobNature ? String(jobNature).trim() : "",
          isBinClearance,
          routeNo: routeNo ? String(routeNo).trim() : "",
          priority,
          model: model ? String(model).trim() : "",
          barcode,
          denominations,
        };

        locations.push(loc);
      }

      if (locations.length > 0) {
        setKioskLocations(locations);
      } else {
        showToast("error", "No valid rows found in excel file.");
      }
    });
  };

  const handleCreateOrders = () => {
    if (kioskLocations.length === 0) {
      return showToast(
        "error",
        "Please upload a valid kiosk open model excel file."
      );
    }

    // payload expected as an array of objects (already shaped)
    createKioskOpenOrders(kioskLocations as any[]);
  };

  const expandChange = (event: {
    dataItem: KioskLocationDetail;
    value: boolean;
  }) => {
    event.dataItem.expanded = event.value;
    setKioskLocations([...kioskLocations]);
  };

  const handleCloseModal = () => {
    setKioskLocations([]);
    setOpenFileUpload(false);
  };

  return (
    <Dialog open={openFileUpload} onOpenChange={handleCloseModal}>
      <DialogContent
        className={cn(kioskLocations.length ? "max-w-[992px]" : "")}
      >
        <DialogHeader>
          <DialogTitle>Kiosk Open Model Orders</DialogTitle>
        </DialogHeader>
        <DialogDescription className="pt-6 space-y-4  max-h-[70vh] overflow-auto">
          {/* Preview Locations */}
          {kioskLocations.length ? (
            <Grid
              data={kioskLocations}
              detail={DetailComponent}
              expandField="expanded"
              onExpandChange={expandChange}
              size="small"
              className="text-[10px]"
            >
              <Column field="barcode" title="Barcode" width="140px" />

              <Column field="jobType" title="Job Type" width="140px" />
              <Column
                field="isBinClearance"
                title="Bin Clearance"
                width="120px"
              />
              <Column
                field="invoicingModel"
                title="Invoicing Model"
                width="140px"
              />
              <Column field="jobNature" title="Job Nature" width="120px" />
              <Column field="priority" title="Priority" width="100px" />
              <Column field="routeNo" title="Route No" width="140px" />
            </Grid>
          ) : (
            <>
              <DateTimePicker
                placeholder="Select Service Date"
                className="w-full h-10"
                value={selectedDate}
                onChange={(e) => {
                  setSelectedDate(e.target.value as Date);
                }}
                min={new Date()}
              />
              <div className="flex items-center justify-center w-full">
                <label
                  htmlFor="dropzone-kiosk-open-model"
                  className="flex flex-col items-center justify-center w-full h-40 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
                >
                  <p className="mb-2 text-sm text-gray-500">
                    <span className="font-semibold">Click to upload</span> or
                    drag & drop
                  </p>
                  <p className="text-xs text-gray-500">
                    XLS, XLSX, CSV (MAX. 5GB)
                  </p>
                  <input
                    id="dropzone-kiosk-open-model"
                    accept=".xlsx, .xls, .csv"
                    type="file"
                    className="hidden"
                    onChange={fileHandler}
                  />
                </label>
              </div>
            </>
          )}

          {/* Submit Button */}
          {kioskLocations.length > 0 && (
            <div className="flex justify-end mt-4 gap-2">
              <Button
                variant="outline"
                onClick={() => {
                  setKioskLocations([]);
                  setOpenFileUpload(false);
                }}
              >
                Cancel
              </Button>
              <Button
                variant="secondary"
                disabled={kioskOrdersPending}
                onClick={handleCreateOrders}
              >
                {kioskOrdersPending ? "Creating..." : "Create Request"}
              </Button>
            </div>
          )}
        </DialogDescription>
      </DialogContent>
    </Dialog>
  );
}
